import * as actionType from '../actions';
import moment from 'moment';

const initialState = {
  bookingStep: 0,
  restaurantId: null,
  restaurantName: null,
  loadingMainInfo: true,
  termsAndConditions: null,
  serviceTimes: {
    Lunch: null,
    Dinner: null
  },
  peopleNumber: 1,
  maxPeopleNumber: 6,
  hasAcceptedTerms: false,
  hasAcceptedPrivacy: false,
  hasAcceptedMailing: false,
  time: null,
  date: moment().format('YYYY-MM-DD'),
  maxDate: moment().add(30, 'day'),
  menuSelection: null,
  roomSelection: null,
}

export const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.ACCEPTED_TERMS_AND_PRIVACY:
      return {
        ...state,
        hasAcceptedTerms: !state.hasAcceptedTerms,
        hasAcceptedPrivacy: !state.hasAcceptedPrivacy
      }
    case actionType.ACCEPTED_MAILINGLIST:
      return {
        ...state,
        hasAcceptedMailing: !state.hasAcceptedMailing
      }
    case actionType.SELECTED_RESTAURANT:
      let services = [...action.serviceTimes];
      const updatedServices = {
        Lunch: services[0].TimeFrom,
        Dinner: services[0].TimeFrom
      }
      return {
        ...state,
        restaurantName: action.restaurantName,
        restaurantId: action.restaurantId,
        maxPeopleNumber: action.maxPeopleNumber,
        termsAndConditions: action.termsAndConditions,
        loadingMainInfo: false,
        serviceTimes: {
          Lunch: updatedServices.Lunch,
          Dinner: updatedServices.Dinner
        }
      }
    case actionType.ADD_PEOPLE:
      return {
        ...state,
        peopleNumber: state.peopleNumber + 1
      }
    case actionType.REMOVE_PEOPLE:
      if (state.peopleNumber <= 1) {
        return state
      } else {
        return {
          ...state,
          peopleNumber: state.peopleNumber - 1
        }
      }
    case actionType.NEXT_STEP:
      return {
        ...state,
        bookingStep: state.bookingStep + 1
      }
    case actionType.BACK_STEP:
      return {
        ...state,
        bookingStep: state.bookingStep - 1
      }
    case actionType.TIME_SELECT:
      return {
        ...state,
        time: action.time
      }
    case actionType.DATE_SELECT:
      return {
        ...state,
        date: action.date
      }
    case actionType.MENU_SELECT:
      return {
        ...state,
        menuSelection: action.menu
      }
    case actionType.ROOM_SELECT:
      return {
        ...state,
        roomSelection: action.room
      }
    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/store/reducers/global.js